import React, {useState} from 'react';
import {TextField, IconButton} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Search } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: theme.spacing(3)
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 300,
    }
}));

export default function SearchConditional(props) {
    const classes = useStyles();
    const {t} = useTranslation('driverPickup');

    const {onSearchClick} = props

    const [manifestNo, setManifestNo] = useState('');

    const handleManifestNoChange = (event) => {
        setManifestNo(event.target.value);
    }

    return (
        <form className={classes.container} noValidate>
            <TextField
                label={t("manifest_no")}
                className={classes.textField}
                value={manifestNo}
                displayEmpty
                variant="outlined"
                onChange={handleManifestNoChange}
            />
            <IconButton color='primary' onClick={() => onSearchClick(manifestNo)} disabled={!manifestNo}>
                <Search />
            </IconButton>
        </form>
    );
}

SearchConditional.defaultProps = {
    onSearchClick: ()=>{}
}